import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c08ff4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-content" }
const _hoisted_2 = { class: "ws_text_overflow ws_mr4" }

import { onMounted, ref, watch, computed } from 'vue'
import { transformLogContent } from '@/utils'
import moment from 'moment'
import LogInfo from './log-info.vue'
import { queryDeviceSourceLog } from '@/api'
import { CODE_ENUM } from '@/common'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'log-source',
  props: ['visible', 'data'],
  emits: ['update:visible'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t

// 事件上报
const EVENT_REPORT_CODE = '1003'




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryData()
    } else {
      tableData.value = []
    }
  }
)

const tableData = ref([])
const tableLoading = ref(false)
const queryData = async () => {
  const id = props.data.logId
  tableLoading.value = true
  const res: any = await queryDeviceSourceLog({
    id,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data || []
  }
}

const cancel = () => {
  $emit('update:visible', false)
}

const formatterSatelliteId = (row: any) => {
  return row.satelliteId || '-'
}
const formatterSatelliteTime = (satelliteTime: any) => {
  return satelliteTime
    ? moment(satelliteTime).format('YYYY-MM-DD HH:mm:ss')
    : '-'
}

// 特殊字段处理
const formatterMap = {
  prodDate: (value: string) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
  location: (value: string) => {
    const result: any = JSON.parse(value)
    const { latitude, longitude } = result
    return t('D_LOG.lng') + longitude + ' ' + t('D_LOG.lat') + latitude
  },
  logDate: (value: string) => {
    return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  },
}

const filterAttr = ['prodDate', 'logDate']

const formatterLogContent = (attrList: any) => {
  return transformLogContent(attrList, formatterMap)
    .map(({ label, value, key }: any) => {
      return filterAttr.includes(key) ? '' : label + ' : ' + value
    })
    .filter(Boolean)
    .join('；')
}

const detailModal = ref({
  rowData: {},
  visible: false,
})

const showLogDetail = (row: any) => {
  detailModal.value = {
    visible: true,
    rowData: row,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Tickets = _resolveComponent("Tickets")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": props.visible,
      "before-close": cancel,
      class: "log-detail-modal",
      width: "90%",
      title: _ctx.$t('D_LOG.logTraceability')
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          class: "ws_mt20 ws_common_table",
          stripe: ""
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('D_LOG.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "logId",
              label: _ctx.$t('D_LOG.logId'),
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.logId), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "deviceName",
              label: _ctx.$t('D_LOG.deviceName'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "logType",
              label: _ctx.$t('D_LOG.logType'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "logContent",
              label: _ctx.$t('D_LOG.logContent'),
              "min-width": "350",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(scope.row.logTypeCode === EVENT_REPORT_CODE
                ? formatterLogContent(scope.row.attrList)
                : scope.row.logContent), 1),
                  (scope.row.logTypeCode === EVENT_REPORT_CODE)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        onClick: ($event: any) => (showLogDetail(scope.row)),
                        class: "icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Tickets)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "transType",
              label: _ctx.$t('D_LOG.transType'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              formatter: formatterSatelliteId,
              prop: "satelliteId",
              label: _ctx.$t('D_LOG.satelliteId'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "prodTime",
              label: _ctx.$t('D_LOG.collectTime'),
              width: "200",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scope.row.prodTime).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "satelliteTime",
              label: _ctx.$t('D_LOG.onboardTime'),
              width: "200",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(formatterSatelliteTime(scope.row.satelliteTime)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "createDate",
              label: _ctx.$t('D_LOG.createTime'),
              width: "200",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "parseStatusValue",
              "show-overflow-tooltip": "",
              label: _ctx.$t('D_LOG.parseStatus'),
              width: "150"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title"]),
    _createVNode(LogInfo, {
      visible: detailModal.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((detailModal.value.visible) = $event)),
      rowData: detailModal.value.rowData,
      formatterMap: formatterMap
    }, null, 8, ["visible", "rowData"])
  ], 64))
}
}

})